import { Close } from '@mui/icons-material';
import { Alert as A, IconButton, Snackbar } from '@mui/material';

export interface AlertProps {
  variant: 'success' | 'error';
  message: string;
  open: boolean;
  onClose: () => void;
}

export function Alert(props: AlertProps) {
  const { variant, message, open, onClose } = props;

  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      action={
        <IconButton size="small" color="inherit" onClick={onClose}>
          <Close fontSize="small" />
        </IconButton>
      }
      onClose={onClose}
    >
      <A
        sx={{ width: '100%', height: 100, alignItems: 'center', fontSize: '1.1rem' }}
        onClose={onClose}
        severity={variant}
        variant="filled"
      >
        {message}
      </A>
    </Snackbar>
  );
}
